function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useContext, useState, useEffect, useRef, forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { AgroHeaderContext } from '../../contexts/AgroHeaderContext/AgroHeaderContext';
import PropTypes from 'prop-types';
import { Isearch2, Iclose, Istore, InavigateLeft } from '../../atoms/AgroIcon/icons';
import { AgroSpinner } from '../../atoms/AgroSpinner';
import { Text } from '../../atoms/Text';
// import logger from '../../utils/logger';

export function getWindowDimensions() {
  if (typeof window !== 'undefined') {
    var _window = window,
      width = _window.innerWidth,
      height = _window.innerHeight;
    return {
      width: width,
      height: height
    };
  }
}
export function useWindowDimensions() {
  var _useState = useState(getWindowDimensions()),
    _useState2 = _slicedToArray(_useState, 2),
    windowDimensions = _useState2[0],
    setWindowDimensions = _useState2[1];
  useEffect(function () {
    if (typeof window !== 'undefined') {
      var handleResize = function handleResize() {
        setWindowDimensions(getWindowDimensions());
      };
      window.addEventListener('resize', handleResize);
      return function () {
        return window.removeEventListener('resize', handleResize);
      };
    }
  }, []);
  return typeof windowDimensions !== 'undefined' ? windowDimensions.width < 992 : false;
}
var SearchBar = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$showClear = _ref.showClear,
    showClear = _ref$showClear === void 0 ? false : _ref$showClear,
    placeholderText = _ref.placeholderText,
    clickCallback = _ref.clickCallback,
    isFocus = _ref.isFocus;
  var _useContext = useContext(AgroHeaderContext),
    baseUrl = _useContext.baseUrl,
    suggestionCallback = _useContext.suggestionCallback,
    onSearchSubmit = _useContext.onSearchSubmit,
    tagManager = _useContext.tagManager,
    translations = _useContext.translations,
    apiGateway = _useContext.apiGateway,
    language = _useContext.language;
  var isMobile = useWindowDimensions();
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    input = _useState4[0],
    setInput = _useState4[1];
  var _useState5 = useState(-1),
    _useState6 = _slicedToArray(_useState5, 2),
    focusId = _useState6[0],
    setFocusId = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    resultsCategories = _useState8[0],
    setResultsCategories = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    resultsOnlineStores = _useState10[0],
    setResultsOnlineStores = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    resultsOther = _useState12[0],
    setResultsOther = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showSpinner = _useState14[0],
    setShowSpinner = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    firstClick = _useState16[0],
    setFirstClick = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    showOther = _useState18[0],
    setShowOther = _useState18[1];
  var inputRef = useRef(null);
  var wrapperRef = useRef(null);
  var country = {
    'es-AR': 'argentina',
    'es-BO': 'bolivia',
    'es-CL': 'chile',
    'es-CO': 'colombia',
    'es-PE': 'peru',
    'es-PY': 'paraguay',
    'es-UY': 'uruguay',
    'pt-BR': 'brasil'
  };
  useEffect(function () {
    (!isMobile || isFocus) && inputRef.current.focus();
    isFocus && handleFocus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFocus]);
  var functionSort = function functionSort(s) {
    s.sort(function (a, b) {
      if (a.Score < b.Score) {
        return 1;
      }
      if (a.Score > b.Score) {
        return -1;
      }
      if (a.Suggestion < b.Suggestion) {
        return 1;
      }
      if (a.Suggestion > b.Suggestion) {
        return -1;
      }
      return 0;
    });
    return s;
  };
  useEffect(function () {
    setFocusId(-1);
  }, [input]);
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        clearList();
        back();
      }
    };
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wrapperRef]);
  var handleKeyCode = function handleKeyCode(e) {
    var keyCode = e.key;
    var list = resultsCategories.length + resultsOnlineStores.length - 1;
    e.stopPropagation();
    var up = function up() {
      var back = focusId === -1 ? -1 : focusId - 1;
      setFocusId(back);
      e.preventDefault();
    };
    var down = function down() {
      var next = focusId === list ? list : focusId + 1;
      setFocusId(next);
      e.preventDefault();
    };
    switch (keyCode) {
      // up arrow
      case 'ArrowUp':
        return up();
      // down arrow
      case 'ArrowDown':
        return down();
      case 'Tab':
        return down();
      default:
        return null;
    }
  };
  var handleFocus = function handleFocus(e) {
    if (!isFocus || e) {
      clickCallback();
    }
    if (!firstClick && input === '' && !isMobile || input === '' && isFocus) {
      fetch("https://apigateway-".concat(country[language], ".agrofy.com/api/suggestions/oneclick")).then(function (response) {
        return response.json();
      }).then(function (data) {
        var _data$Content$others_;
        var otherSuggest = ((_data$Content$others_ = data.Content.others_suggest) === null || _data$Content$others_ === void 0 ? void 0 : _data$Content$others_.Suggestions) || [];
        var othersSuggest = functionSort(otherSuggest);
        var filterOthers = othersSuggest.slice(0, 6);
        filterOthers && filterOthers.length && setResultsOther(filterOthers.map(function (item, idx) {
          return {
            item: item,
            id: idx + filterOthers.length
          };
        }));
      });
      setFirstClick(true);
      setShowOther(true);
    } else if (input === '' && firstClick && !showOther) {
      setShowOther(true);
    } else if (input.length) {
      inputKeyUp();
    }
  };
  var highlightMatches = function highlightMatches(text, matchedFrom, matchedTo) {
    var bold = text.substring(matchedFrom, matchedTo);
    if (matchedFrom === 0) {
      var t = text.substring(matchedTo, text.length);
      return /*#__PURE__*/React.createElement(Text, {
        type: "body-md"
      }, /*#__PURE__*/React.createElement(Text, {
        type: "label-md",
        color: "gray900"
      }, bold), t);
    } else {
      var first = text.substring(0, matchedFrom);
      var second = text.substring(matchedTo, text.length);
      return /*#__PURE__*/React.createElement(Text, {
        type: "body-md"
      }, first, /*#__PURE__*/React.createElement(Text, {
        type: "label-md",
        color: "gray900"
      }, bold), second);
    }
  };
  var getList = function getList(List, categoryName) {
    return List.map(function (data) {
      return /*#__PURE__*/React.createElement("li", {
        key: "".concat(data.item.Suggestion, "-").concat(data.id),
        "data-cy": "suggestion",
        className: data.id === focusId ? 'focus' : ''
      }, categoryName === 'Agroshop' ? /*#__PURE__*/React.createElement(Istore, {
        "data-cy": "icon-store",
        fill: "gray600",
        height: "19.45px",
        width: "19.45px"
      }) : /*#__PURE__*/React.createElement(Isearch2, {
        "data-cy": "icon-search",
        fill: "gray600",
        height: "21.76px",
        width: "21.76px"
      }), /*#__PURE__*/React.createElement("a", {
        key: data.id,
        href: "".concat(baseUrl).concat(data.item.Url),
        onClick: function onClick() {
          return onSearchSubmit('search', data.item.Suggestion);
        },
        onMouseDown: function onMouseDown() {
          return gtmSearch(categoryName, data.item.Suggestion);
        }
      }, highlightMatches(data.item.Suggestion, data.item.MatchedFrom, data.item.MatchedTo)));
    });
  };
  var inputKeyUp = function inputKeyUp(e) {
    var value = e !== null && e !== void 0 && e.target.value || (e === null || e === void 0 ? void 0 : e.target.value) === '' ? e.target.value : input;
    setInput(value);
    setFocusId(-1);
    if (value.length >= 1) {
      setShowOther(false);
      setShowSpinner(true);
      suggestionCallback(value).then(function (res) {
        setShowSpinner(false);
        if (res.data.Content != null) {
          setResultsCategories([]);
          setResultsOnlineStores([]);

          //Suggester service returns sorted suggestions so just concat response and filter
          var n1 = res.data.Content.categoryname_suggester.Suggestions || [];
          n1 = functionSort(n1);
          var filteredCategories = n1.slice(0, 3);
          filteredCategories && filteredCategories.length > 0 && setResultsCategories(filteredCategories.map(function (item, idx) {
            return {
              item: item,
              id: idx
            };
          }));

          //Get shops suggestions and filter three of them
          var suggestedShops = res.data.Content.agroshopname_suggester.Suggestions || [];
          suggestedShops = functionSort(suggestedShops);
          var filteredShops = suggestedShops.slice(0, 3);
          filteredShops && filteredShops.length && setResultsOnlineStores(filteredShops.map(function (item, idx) {
            return {
              item: item,
              id: idx + filteredCategories.length
            };
          }));
        } else {
          setResultsCategories([]);
          setResultsOnlineStores([]);
        }
      })["catch"](function (error) {
        clearList();
        setShowSpinner(false);
        console.error(error);
      });
    } else {
      setResultsCategories([]);
      setResultsOnlineStores([]);
    }
  };
  var getFocusValue = function getFocusValue() {
    var findItem = [].concat(_toConsumableArray(resultsOnlineStores), _toConsumableArray(resultsCategories)).find(function (data) {
      return data.id === focusId;
    });
    var newValue = findItem.item.Url.replace(/^\//, '');
    return newValue;
  };
  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    var searchWords = focusId > -1 ? getFocusValue() : event.target.elements['search-input'] && event.target.elements['search-input'].value.trim().toLowerCase();
    gtmSearch();
    if (searchWords && searchWords.length) {
      try {
        onSearchSubmit('search', searchWords).then(function () {
          var searchTerm = searchWords.trim().toLowerCase().replace(/[ ] +/g, ' ');
          var requestOptions = {
            method: 'POST'
          };
          fetch("".concat(apiGateway, "/searches/logs/?searchTerm=").concat(searchTerm), requestOptions);
          window.location = "".concat(window.location.origin, "/").concat(searchWords.replace(/[ ] +/g, ' ').replace(/[/ ]/g, '-').replace(/[#]/g, ''));
        });
      } catch (e) {
        console.error('No se especificó una Promise para onSearchSubmit', e);
      }
    }
  };
  var clear = function clear(event) {
    event.preventDefault();
    setInput('');
    clearList();
    inputRef.current.focus();
  };
  var clearList = function clearList() {
    setResultsCategories([]);
    setResultsOnlineStores([]);
  };
  var gtmSearch = function gtmSearch(categoryType, categoryName) {
    if (tagManager) {
      var tagManagerArgs = {
        dataLayer: {
          event: 'search',
          search_term: categoryType && categoryName ? "".concat(categoryType, "_").concat(categoryName) : input,
          n_character: input.length
        }
      };
      tagManager(tagManagerArgs);
    }
  };
  var showTranslation = function showTranslation(translation) {
    return translations[translation];
  };
  var back = function back() {
    setShowOther(false);
    if (isFocus) {
      clickCallback();
    }
  };
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: handleSubmit,
    ref: wrapperRef
  }, /*#__PURE__*/React.createElement(SearchContainer, null, /*#__PURE__*/React.createElement(SearchList, {
    isFocus: isFocus,
    isMobile: isMobile
  }, isFocus && isMobile && /*#__PURE__*/React.createElement(BackContainer, {
    onClick: function onClick() {
      return back();
    }
  }, /*#__PURE__*/React.createElement(InavigateLeft, {
    fill: "gray800",
    height: "24px",
    width: "24px"
  })), /*#__PURE__*/React.createElement(SpinnerContainer, {
    isFocus: isFocus
  }, showSpinner ? /*#__PURE__*/React.createElement(AgroSpinner, {
    size: "14px",
    variant: "gray"
  }) : null), /*#__PURE__*/React.createElement(Input, {
    ref: inputRef,
    type: "text",
    name: "search-input",
    value: input,
    onClick: function onClick() {
      return handleFocus();
    },
    onChange: function onChange(e) {
      return inputKeyUp(e);
    },
    onKeyDown: function onKeyDown(e) {
      return handleKeyCode(e);
    },
    placeholder: placeholderText ? placeholderText : showTranslation('search'),
    autoComplete: "off",
    showClear: showClear,
    showSpinner: showSpinner,
    "data-cy": "input-suggester"
  }), showClear || isFocus && isMobile ? /*#__PURE__*/React.createElement(Clear, {
    onClick: function onClick(event) {
      return clear(event);
    },
    type: "button"
  }, /*#__PURE__*/React.createElement(Iclose, {
    height: "20.58px",
    width: "20.58px",
    fill: "#7d7d7d"
  })) : null), !isFocus && /*#__PURE__*/React.createElement(SearchLink, {
    href: "".concat(baseUrl, "/").concat(input)
  }, /*#__PURE__*/React.createElement(ButtonSearch, {
    title: placeholderText ? placeholderText : showTranslation('search').slice(0, -3)
  }, /*#__PURE__*/React.createElement(IconSearch, {
    height: "24px",
    width: "24px",
    fill: "gray700"
  })))), resultsCategories || resultsOnlineStores || resultsOther ? /*#__PURE__*/React.createElement(SuggestionWrapper, {
    isMobile: isMobile
  }, resultsCategories && resultsCategories.length && input.length ? /*#__PURE__*/React.createElement("ul", {
    className: "suggestions searching"
  }, /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, showTranslation('categories')), getList(resultsCategories, 'Category')) : null, resultsOnlineStores && resultsOnlineStores.length && input.length ? /*#__PURE__*/React.createElement("ul", {
    className: "suggestions searching"
  }, /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, showTranslation('onlineStores')), getList(resultsOnlineStores, 'Agroshop')) : null, resultsOther && resultsOther.length && !resultsCategories.length && !resultsOnlineStores.length && showOther ? /*#__PURE__*/React.createElement("ul", {
    className: "suggestions searching"
  }, getList(resultsOther, 'Other')) : null) : null);
});
SearchBar.propTypes = {
  showSearchIcon: PropTypes.bool,
  showClear: PropTypes.bool,
  placeholderText: PropTypes.string
};
SearchBar.displayName = 'SearchBar';
export { SearchBar };
var SearchContainer = styled.div.withConfig({
  displayName: "SearchBar__SearchContainer",
  componentId: "sc-1dztxtb-0"
})(["display:flex;@media (min-width:", "){width:100%;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoint.lg;
});
var Form = styled.form.withConfig({
  displayName: "SearchBar__Form",
  componentId: "sc-1dztxtb-1"
})(["position:relative;", ""], function (_ref3) {
  var theme = _ref3.theme;
  return css(["@media (min-width:", ") and (max-width:", "){flex-grow:1;margin:0px 5%;}@media (min-width:", "){width:375px;}@media (max-width:", "){width:100%;}"], theme.breakpoint.sm, theme.breakpoint.lg, theme.breakpoint.lg, theme.breakpoint.lg);
});
var SearchLink = styled.a.withConfig({
  displayName: "SearchBar__SearchLink",
  componentId: "sc-1dztxtb-2"
})(["z-index:3;", ""], function (_ref4) {
  var theme = _ref4.theme;
  return css(["@media (max-width:", "){pointer-events:none;cursor:default;}"], theme.breakpoint.lg);
});
var IconSearch = styled(Isearch2).withConfig({
  displayName: "SearchBar__IconSearch",
  componentId: "sc-1dztxtb-3"
})(["@media (max-width:", "){height:16px;width:16px;}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoint.lg;
});
var BackContainer = styled.div.withConfig({
  displayName: "SearchBar__BackContainer",
  componentId: "sc-1dztxtb-4"
})(["display:none;@media (max-width:", "){display:flex;justify-content:center;align-items:center;border:1px solid #ddd;border-right:0;border-left:0;background-color:#fff;padding-left:16px;}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoint.lg;
});
var SpinnerContainer = styled.div.withConfig({
  displayName: "SearchBar__SpinnerContainer",
  componentId: "sc-1dztxtb-5"
})(["display:flex;justify-content:center;align-items:center;border:1px solid #ddd;border-right:0;background-color:#fff;border-radius:8px 0 0 8px;padding:0px 2px;@media (max-width:", "){", "}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoint.lg;
}, function (_ref8) {
  var isFocus = _ref8.isFocus;
  return isFocus && css(["border-left:0px;border-radius:0;"]);
});
var Input = styled.input.withConfig({
  displayName: "SearchBar__Input",
  componentId: "sc-1dztxtb-6"
})(["padding-left:16px;border:1px solid #ddd;border-right:0;border-left:0;background-color:#fff;color:", ";display:inline-block;font-family:Montserrat;font-size:14px;font-weight:500;margin:0;width:100%;letter-spacing:-0.20000000298023224px;line-height:24px;border-radius:0px;::placeholder,::-webkit-input-placeholder{color:", " !important;}:-ms-input-placeholder{color:", " !important;}&:focus{outline:none;}", " ", ""], function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.gray700;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.gray700;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.gray700;
}, function (_ref12) {
  var showClear = _ref12.showClear;
  return showClear && css(["padding-right:36px;"]);
}, function (_ref13) {
  var showSpinner = _ref13.showSpinner;
  return showSpinner && css(["padding-left:2px;"]);
});
var ButtonSearch = styled.button.withConfig({
  displayName: "SearchBar__ButtonSearch",
  componentId: "sc-1dztxtb-7"
})(["background:", ";cursor:pointer;border-radius:0px 8px 8px 0px;border:1px solid #ddd;border-bottom:1px solid #ddd;border-left:0;transition:all 0.2s ease-in-out;width:40px;height:41px;color:white;z-index:2;display:flex;justify-content:center;align-items:center;outline:none;"], function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.white;
});
var Clear = styled.button.withConfig({
  displayName: "SearchBar__Clear",
  componentId: "sc-1dztxtb-8"
})(["padding:10px;margin:2px;position:absolute;top:0px;right:0px;display:flex;z-index:100;background:none;border:none;cursor:pointer;justify-content:center;align-items:center;transition:all 0.2s ease-in;height:54px;&:focus,&:active{border:none;outline:none;}&:hover{@media (min-width:", "){background-color:", ";border-radius:50%;}}"], function (_ref15) {
  var theme = _ref15.theme;
  return theme.breakpoint.lg;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.gray200;
});
var SearchList = styled.div.withConfig({
  displayName: "SearchBar__SearchList",
  componentId: "sc-1dztxtb-9"
})(["display:flex;position:relative;width:100%;height:41px;z-index:1;input{::placeholder{color:", ";}}> span{display:none;}", ""], function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.gray700;
}, function (_ref18) {
  var isFocus = _ref18.isFocus,
    isMobile = _ref18.isMobile;
  return isFocus && isMobile && css(["height:54px;"]);
});
var SuggestionWrapper = styled.div.withConfig({
  displayName: "SearchBar__SuggestionWrapper",
  componentId: "sc-1dztxtb-10"
})(["background-color:#ffffff;border-radius:0 0 5px 5px;box-shadow:0 6px 10px 0 rgba(94,94,94,0.35);font-family:Montserrat;font-size:14px;font-weight:500;max-height:480px;width:100%;overflow-y:auto;position:absolute;margin-top:-4px;span.title{text-align:left;color:", ";padding:18px 0px 10px 16px;font-size:12px;line-height:18px;display:block;font-weight:600;}ul{list-style:none;padding:0;margin:0;}li{display:flex;flex-direction:row;align-items:center;padding-left:16px;:hover{background-color:", ";}}li a{text-decoration:none;color:#454545;padding:10px 16px;display:block;width:100%;}li > a:hover,li.focus,a:focus{background-color:", ";}"], function (_ref19) {
  var theme = _ref19.theme;
  return theme.colors.gray800;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.colors.gray200;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.colors.gray2;
});